// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"re_a bhl_a bhl_r bhl_sb bhl_ry bhl_rz","GroupsGrid__row__item":"re_b bhl_be bhl_rz"};